import { useNavigate } from "react-router";
import { useHotkeys } from "react-hotkeys-hook";
import { useDarkStore } from "@client/store/dark";
import { useUIStore } from "@client/store/ui";
import { useUserStore } from "@client/store/user";

/**
 * Globální klávesové zkratky.
 * Volat jednou na nejvyšší úrovni dashboardu.
 */
export const useGlobalShortcuts = () => {
  const setSettingsOpen = useUIStore((s) => s.setSettingsOpen);
  const toggleChartLock = useUIStore((s) => s.toggleChartLock);
  const setEditMode = useUIStore((s) => s.setEditMode);
  const editMode = useUIStore((s) => s.editMode);
  const toggleDark = useDarkStore((s) => s.toggleDark);
  const user = useUserStore((s) => s.user);
  const isAdmin = typeof user === "object" && user !== null && (user as { role: string }).role === "ADMIN";
  const nav = useNavigate();

  // S = otevřít Settings
  useHotkeys("s", () => setSettingsOpen(true), { preventDefault: true });
  // L = toggle chart lock
  useHotkeys("l", () => toggleChartLock(), { preventDefault: true });
  // D = toggle dark mode
  useHotkeys("d", () => toggleDark(), { preventDefault: true });
  // E = toggle edit mode (jen admin — layouty jsou globální)
  useHotkeys("e", () => isAdmin && setEditMode(!editMode), { preventDefault: true });
  // ? = help
  useHotkeys("shift+/", () => alert(SHORTCUT_HELP), { preventDefault: true });
  // / = focus na hlavní app (placeholder)
  useHotkeys("g h", () => nav("/"), { preventDefault: true });
};

const SHORTCUT_HELP = `Klávesové zkratky:

S — Otevřít nastavení
L — Zamknout/odemknout grafy
D — Tmavý/světlý režim
E — Edit mode (uspořádání widgetů)
G H — Zpět na dashboard
? — Tato nápověda
Esc — Zavřít dialog/drawer
`;
